import React from 'react';
import { getDetailsUrl } from 'util/mediaUtil';
import { Link } from 'react-toolbox/lib/link';
import Ripple from 'react-toolbox/lib/ripple';
import theme from 'application/components/MediaLinkTheme.css';

const MediaLink = Ripple({ spread: 2 })(({ media, ...props }) =>
  <Link
    href={getDetailsUrl(media)}
    target="_blank"
    onClick={e => e.stopPropagation()}
    {...props}
    theme={theme}
  />,
);

export default MediaLink;
